import React from 'react'

const SvgRollerBrushOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 4a2 2 0 012-2h11a2 2 0 012 2v1a3 3 0 013 3v1.85a3 3 0 01-3 3h-5a1 1 0 00-1 1V15h1v5a2 2 0 11-4 0v-5h1v-1.15a3 3 0 013-3h5a1 1 0 001-1V8a1 1 0 00-1-1 2 2 0 01-2 2H5a2 2 0 01-2-2V4zm2 0h11v3H5V4z'
    />
  </svg>
)

export default SvgRollerBrushOutline
